import styled from 'styled-components'

const Link_ = styled.a`
    color: #6745b0;
    text-decoration-line: none;
    text-decoration-style: double;
    margin-left: 10px
    `

export default Link_;